/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{number as r}from"../../../value/types/numbers/index.js";const o={...r,transform:Math.round};export{o as int};
//# sourceMappingURL=type-int.js.map
